import { atom } from "recoil";
import { createFolders } from "./CreateFolders.types";

export const createFolder = atom<createFolders>({
    key: "CreateFolder",
    default: { pending: true, fulfilled: false, sites: [], totalCount:0 },
  });
